<div class="table-card-toolbar nx-margin-bottom-s">
  <h4 class=" back-right nx-margin-y-s"
    [ngClass]="{'mobile-hading':mobile}">
    {{ title | caption }}
  </h4>

  @if (!mobile) {
    @if (viewChangers != undefined) {
      @for (viewChangerEntry of viewChangers | keyvalue; track viewChangerEntry) {
        <button
          nxButton="{{viewChangerEntry.value.show?'cte':'tertiary'}} small"
          [attr.aria-label]="viewChangerEntry.value.viewName"
          type="button"
          class="nx-margin-right-s nx-margin-bottom-0"
          (click)="changeView(viewChangerEntry.key)"
          >
          <nx-icon name="{{viewChangerEntry.value.icon}}"></nx-icon>
        </button>
      }
    }
    @if (newSupplier && hasPermission) {
      <button (click)="newSupplier()"
        nxButton="primary small"
        aria-label="new"
        type="button">
        <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>
        {{ 'general.new' | caption }}
      </button>
    }
  }

  @if (mobile && menuWantedInMobileView) {
    <button
      nxIconButton="cte small"
      [nxContextMenuTriggerFor]="menu"
      aria-label="Open menu"
      type="button"
      >
      <nx-icon aria-hidden="true" name="ellipsis-h"></nx-icon>
    </button>
    <nx-context-menu #menu="nxContextMenu">
      @if (viewChangers != undefined) {
        @for (viewChangerEntry of viewChangers | keyvalue; track viewChangerEntry) {
          <button
            nxContextMenuItem
            [attr.aria-label]="viewChangerEntry.value.viewName"
            type="button"
            class="nx-margin-right-s nx-margin-bottom-0"
            (click)="changeView(viewChangerEntry.key)"
            >
            <nx-icon name="{{viewChangerEntry.value.icon}}"></nx-icon>
            <span
            [ngClass]="{'active-view':viewChangerEntry.value.show}">{{ 'general.' + viewChangerEntry.value.viewName | caption }}</span>
          </button>
        }
      }
      @if (newSupplier && hasPermission) {
        <button (click)="newSupplier()"
          nxContextMenuItem
          aria-label="a useful label"
          type="button">
          <nx-icon name="plus" class="nx-margin-right-2xs"></nx-icon>
          {{ 'general.new' | caption }}
        </button>
      }
    </nx-context-menu>
  }

  @if (mobile && onlyAddNewButtonWantedInMobileView) {
    <button nxButton="primary small" type="button" (click)="newSupplier?.()">
      <nx-icon name="save-o" class="nx-margin-right-2xs"></nx-icon>
      {{ 'general.new' | caption }}
    </button>
  }

</div>

